const { h, render, Component } = require('preact');
const {Portal} = require('preact-portal');

class FinePrint extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false
    }
    this.openPopup = this.openPopup.bind(this);
    this.closePopup = this.closePopup.bind(this);
  }

  openPopup() {
    this.setState({open: true});
  }

  closePopup() {
    this.setState({open: false});
  }

  render() {
    let finePrint = this.props.getFinePrintInformation
    if (finePrint) {
      return (
        <div class="ssa-links">
          <span class="ssa-link" data-bhw="web2018_fine_print_link" onClick={this.openPopup}>
            {I18n.translate("js.modules.support.viewfp")}
          </span>
          {this.state.open && (
            <Portal into="body">
              <div class="popup" data-bhw="web2018_fine_print_popup">
                <div>
                  <span class="icon-x" data-bhw="web2018_fine_print_close_button" onClick={this.closePopup}></span>
                </div>
                <div class="ssa-link-title">
                  {I18n.translate("js.modules.support.fp")}
                </div>
                {finePrint}
              </div>
              <div class="shadow"></div>
            </Portal>
          )
          }
        </div>
      );
    }
    return null;
  }
}
module.exports = FinePrint
